module.exports = "https://static.im-cdn.com/mjc/storefront/Esteem/static/media/testLeft.b2b07af4.svg";